import { isBoolean } from '@sindresorhus/is';
import { AbstractMigration } from '../base/abstract-migration.ts';

export class PinVersionsMigration extends AbstractMigration {
  override readonly deprecated = true;
  override readonly propertyName = 'pinVersions';

  override run(value: unknown): void {
    if (isBoolean(value)) {
      this.setSafely('rangeStrategy', value ? 'pin' : 'replace');
    }
  }
}
